import React from 'react'

import { useLockBodyScroll } from '../../../hooks'
import { InternalModal, InternalModalProps } from './InternalModal'
import { ModalBody } from './ModalBody'
import { ModalFooter } from './ModalFooter'

export type ModalProps = InternalModalProps

type ModalComponent = React.FC<ModalProps> & {
  Body: typeof ModalBody
  Footer: typeof ModalFooter
}

/**
 * Modal component
 */
export const Modal: ModalComponent = ({ open, ...props }: ModalProps) => {
  useLockBodyScroll(open)

  return <InternalModal open={open} {...props} />
}

Modal.Body = ModalBody
Modal.Footer = ModalFooter
